import api from "./api";

export async function fetchGroups(token: string) {
  try {
    const response = await api.get("users/groups/", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      const groups = response.data;
      return groups;
    }
  } catch (err: any) {
    console.error("Login failed:", err);
  }
}
